<template>
  <v-container fluid class="pa-0">
      <v-img src="@/assets/title_pic.jpg" width="100%" height="90vh">
        <div id="title-box" class="d-flex flex-column align-center justify-center py-7">
          <span id="main-title">Arte & Arte</span>
          <span id="secondary-title" class="text-center">F.lli Regonesi - Decorazioni e restauri</span>
        </div>
      </v-img>

    <div class="spacer"></div>

    <v-row class="justify-center">
      <v-col cols="12" sm="6" md="5" lg="4" class="d-flex justify-end align-center px-8">
        <p class="home-text" >
          Stefano e Bruno Regonesi, diplomati all'Accademia di Belle Arti di Brera a Milano, fondano nel 1989 la ditta
          di restauri e decorazioni artistiche Arte&Arte.
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="5" lg="4" class="d-flex justify-center px-8">

      <v-img class="clip-nonagon"
             src="@/assets/home1.jpg"
             :width="$vuetify.breakpoint.xsOnly ? '90vw': '40vw'"
             :aspect-ratio="1"
      />
      </v-col>
    </v-row>

    <div class="spacer"></div>

    <v-row class="justify-center d-flex flex-column-reverse flex-sm-row">
      <v-col cols="12" sm="8" class="d-flex justify-center px-8">
        <v-img :class="{'arrow-clip': !$vuetify.breakpoint.xsOnly}"
               src="@/assets/home2.jpg"
               :width="$vuetify.breakpoint.xsOnly ? '90vw': '40vw'"
               :aspect-ratio="2"
        />
      </v-col>
      <v-col cols="12" sm="4" md="4" lg="4" class="d-flex justify-start align-center">
        <p class="home-text px-8" >
          Le conoscenze e competenze acquisite nell'arco pluridecennale della nostra esperienza lavorativa, così come
          le abilitazioni ottenute e certificate dall'Albo dei restauratori, ci consentono di effettuare restauri completi.
          Particolare attenzione viene posta all'aspetto metodologico e alle fasi di progettazione, documentazione e
          diagnostica.
        </p>
      </v-col>
    </v-row>

    <div class="spacer"/>

    <v-hover v-slot="{ hover }">
      <v-img :src="$vuetify.breakpoint.xsOnly ? require('@/assets/gallery_tall.jpg') : require('@/assets/home4.jpg')"
             width="100vw" id="explore-gallery-img" @click="goToGallery">
        <v-overlay :value="1" absolute color="red lighten-1"
                   :opacity=" hover ? 1 : 0.45" transition="slide-y-transition">
          <span id="explore-gallery-text" >Esplora la galleria!</span>
        </v-overlay>

      </v-img>
    </v-hover>

    <div class="spacer"></div>

    <v-row class="justify-center">
      <v-col cols="12" sm="6" md="5" lg="4" class="d-flex justify-end align-center px-8">
        <p class="home-text" >
          Parallelamente all'attività di restauro vengono svolte decorazioni artistiche su pareti, soffitti, mobili ed
          elementi d'arredo. Le nostre progettazioni partono dall'esigenza della committenza e del contesto in cui sono
          collocate: dai grandi alberghi alle ville private. Siamo attivi principalmente a Bergamo, Brescia e Milano;
          nostri lavori si trovano anche in altre regioni italiane e all'estero.
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="5" lg="4" class="d-flex justify-center px-8">

        <v-img
               src="@/assets/home5.jpg"
               :width="$vuetify.breakpoint.xsOnly ? '90vw': '40vw'"
               :aspect-ratio="1"
        />
      </v-col>
    </v-row>

    <v-card id="contatti" color="black" class="white--text mt-10" tile elevation="0">
      <v-row justify="center">
        <v-card-title class="contatti-title">Contatti</v-card-title>
      </v-row>

      <v-row>
        <v-col cols="12" md="4" class="d-flex flex-column align-center">
          <v-icon size="100" color="white" class="mb-12">mdi-map-marker</v-icon>
          <span class="contatti-item">Via E.Fermi 20, Zanica (BG)</span>
          <span class="contatti-item">CF e P.IVA: 04344470168</span>
        </v-col>

        <v-col cols="12" md="4" class="d-flex flex-column align-center">
          <v-icon size="100" color="white" class="mb-12">mdi-phone</v-icon>
            <span class="contatti-name">Stefano</span>
            <span class="contatti-item">+39 335 809 0016</span>
            <span class="contatti-name">Bruno</span>
            <span class="contatti-item">+39 339 847 6539</span>


        </v-col>

        <v-col cols="12" md="4" class="d-flex flex-column align-center">
          <v-icon size="100" color="white" class="mb-12">mdi-email</v-icon>
          <span class="contatti-name">Stefano</span>
          <span class="contatti-item">sregonesi@alice.it</span>

          <span class="contatti-name">Bruno</span>
          <span class="contatti-item">brunoregonesi@alice.it</span>

          <span class="contatti-name">PEC</span>
          <span class="contatti-item">arteearte@arubapec.it</span>
        </v-col>
      </v-row>
    </v-card>


    <v-img src="@/assets/lab.jpg" :aspect-ratio="$vuetify.breakpoint.xsOnly ? 1.5 : 3">
    </v-img>

  </v-container>
</template>

<script>
  export default {
    name: "Home",
    data () {
      return {
      }
    },
    methods: {
      goToGallery() {
        window.scrollTo({ top: 0 })
        this.$router.push('gallery')
      }
    }
  }
</script>

<style scoped lang="scss">

#contatti {
  font-family: 'Patrick Hand', cursive;
}

  #title-box {
    background-color: rgba(0, 0, 0, 0.8);
    color: white;
    width: 100%;
    position: absolute;
    bottom: 0;
    font-family: 'Patrick Hand', cursive;

    #main-title {
      font-size: 3rem;
    }

    #secondary-title {
      font-size: 1.6rem;
    }
  }

  .home-text {
    font-family: 'Itim', cursive;
    font-size: 1.6rem;
    text-align: justify;
    text-justify: inter-character;
    max-width: 500px;
  }

  .spacer {
    height: 5vh;
  }

  .clip-nonagon {
    clip-path: polygon(50% 0%, 83% 12%, 100% 43%, 94% 78%, 68% 100%, 32% 100%, 6% 78%, 0% 43%, 17% 12%);
  }

  .absolute {
    position: absolute;
  }

  .arrow-clip {
    clip-path: polygon(0% 0%, 75% 0%, 100% 50%, 75% 100%, 0% 100%);
  }

  #explore-gallery-text {
    font-size: 3rem;
    font-family: 'Patrick Hand', cursive;
  }

  #explore-gallery-img {
    cursor: pointer;
  }


  .contatti-title {
    font-size: 1.7rem;
  }

  .contatti-name {
    font-size: 1.5rem;
  }

  .contatti-item {
    font-size: 1.3rem;
    margin-bottom: 1rem;
  }
</style>